import React, { useRef, useEffect } from 'react';
import InteriorGallery from '../InteriorGallery/InteriorGallery';
import MainLodgeSection from '../MainLodgeSection/MainLodgeSection';
import RestaurantBanner from '../RestaurantBanner/RestaurantBanner';
import Accommodations from '../Accommodations/Accommodations';
import CombineSection from '../CombineSection/CombineSection';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './PremiumCarousel.css';

interface PremiumCarouselProps {
  property?: string;
}

const PremiumCarousel: React.FC<PremiumCarouselProps> = ({ property = "patagonia" }) => {
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cleanup = initializeDragScroll('draggable-carousel');
    return () => {
      if (cleanup && typeof cleanup === 'function') {
        cleanup();
      }
    };
  }, []);

  return (
    <div className="premium-carousel-container">
      <div className="horizontal-scroll-carousel__scroll-container" ref={carouselRef} id="draggable-carousel">
        
        {/* Slide 1: Frame 3831 - Interior Gallery */}
        <div className="carousel-slide">
          <InteriorGallery property={property} />
        </div>

        {/* Slide 2: Main Lodge Section (Scrollable from 1485 to Rectangle 12) */}
        <div className="carousel-slide main-lodge-wide">
          <MainLodgeSection property={property} />
        </div>

        {/* Slide 3: Frame 3815 - Restaurant Banner */}
        <div className="carousel-slide">
          <RestaurantBanner property={property} />
        </div>

        {/* Slide 4: Rectangle 1483 - Accommodations */}
        <div className="carousel-slide">
          <Accommodations property={property} />
        </div>

        {/* Slide 5: Frame 3934 - Combine Lodges */}
        <div className="carousel-slide">
          <CombineSection property={property} />
        </div>

      </div>
    </div>
  );
};

export default PremiumCarousel; 